export type CountryCode = 'EU' | 'TN' | 'MA' | 'IN';

export interface LocalizedPrice {
  currency: string;
  price: number;
}

export const PRICING = {
  basic: {
    EU: { currency: 'EUR', price: 99 },
    TN: { currency: 'TND', price: 380 },
    MA: { currency: 'MAD', price: 950 },
    IN: { currency: 'INR', price: 8900 },
  },

  premium: {
    EU: { currency: 'EUR', price: 500 },
    TN: { currency: 'TND', price: 1900 },
    MA: { currency: 'MAD', price: 4800 },
    IN: { currency: 'INR', price: 45000 },
  },

  full_package: {
    EU: { currency: 'EUR', price: 1000 },
    TN: { currency: 'TND', price: 3800 },
    MA: { currency: 'MAD', price: 9600 },
    IN: { currency: 'INR', price: 89900 },
  },
} as const;